import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import common from '@/router/common'
import main from '@/router/main'

let router = [];

router = router.concat(common)      //公共路由
router = router.concat(main)      //首页路由

export const constantRouterMap = router
export default new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap,
    mode: 'history'
})




// WEBPACK FOOTER //
// ./src/router/index.js